import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useStaffAuth } from '../../context/StaffAuthContext';

const FORCE_CHANGE_PATH = '/staff/cambiar-contrasena';

export function StaffProtectedRoute() {
  const { isAuthenticated, loading, user } = useStaffAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="staff-login-page">
        <p>Cargando…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/staff/login" replace />;
  }

  if (user?.mustChangePassword && location.pathname !== FORCE_CHANGE_PATH) {
    return <Navigate to={FORCE_CHANGE_PATH} replace />;
  }

  return <Outlet />;
}

export function StaffGuestRoute() {
  const { isAuthenticated, loading } = useStaffAuth();

  if (loading) {
    return (
      <div className="staff-login-page">
        <p>Cargando…</p>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/staff" replace />;
  }

  return <Outlet />;
}
